export default __webpack_public_path__ + "static/media/bookImg2.615f1994.svg";